import axios from "../interceptors/axiosInterceptor";
import { SOMETHING_WENT_WRONG } from "config/constants";
import { getAuthOptions } from "config/Headers";
import { UPLOAD_IMAGE_URL } from "config/Url";
import { normalizeCatchErrors } from "./errorUtils";

export const uploadImageApiCall = (entity: string, payload: FormData) =>
    new Promise<any>((resolve, reject) => {
        const imgUrl = UPLOAD_IMAGE_URL.replace("{entity}", entity);
        axios
            .post(imgUrl, payload, getAuthOptions(true))
            .then((response) => {
                if (response) {
                    resolve(response.data);
                } else {
                    reject({ errors: SOMETHING_WENT_WRONG });
                }
            })
            .catch((error) => {
                const errorPayload = normalizeCatchErrors(error.response);
                reject(errorPayload);
            });
    });


